// extracted by mini-css-extract-plugin
module.exports =  {"flash":"QueuedToggler__flash--eQ","queuedIcon":"QueuedToggler__queuedIcon--fY","extraHighlight":"QueuedToggler__extraHighlight--nj"};